import '@scss/App.scss'
export const creatreSvgStamp = (text, fontFamily, options = {}) => {
  const width = options.width || 100;
  const height = options.height || 100;
  const strokeColor = options.strokeColor || '#ff0000';
  const strokeWidth = options.strokeWidth || 2.3;
  let svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}">\n`;

  const centerX = width / 2;
  const centerY = height / 2;

  let lines = [text];
  let isCircle = text.length >= 4;

  if (isCircle) {
    const mid = Math.ceil(text.length / 2);
    lines = [text.slice(0, mid), text.slice(mid)];
  }

  // 글자 크기 계산
  let fontSize 
  if (isCircle) {
    // 4글자 이상: 원 안에 맞추기
    fontSize = Math.floor(width / (Math.max(...lines.map(l => l.length)) + 1.5));
  } else {
    // 3글자 이하: 타원 안에 맞춤
    fontSize = Math.floor(width * 0.2); // 글자가 타원 밖으로 안나가게 조정
  }

  // 도형 그리기
  if (isCircle) {
    const r = Math.min(width, height) / 2 - strokeWidth - 2;
    svg += `  <circle fill="none" stroke="${strokeColor}" stroke-width="${strokeWidth}" cx="${centerX}" cy="${centerY}" r="${r}"></circle>\n`;
  } else {
    const rx = width * 0.3;
    const ry = height / 2 - strokeWidth - 2;
    svg += `  <ellipse fill="none" stroke="${strokeColor}" stroke-width="${strokeWidth}" cx="${centerX}" cy="${centerY}" rx="${rx}" ry="${ry}"></ellipse>\n`;
  }

  if (isCircle) {
    // 2줄 수평 배치
    const lineSpacing = fontSize * 1.0;
    const totalHeight = lines.length * lineSpacing;
    let startY = centerY - totalHeight / 2 + fontSize * 0.8;

    for (const line of lines) {
      const textWidth = line.length * fontSize * 0.9; // 약간 여유
      let startX = centerX - textWidth / 2 + fontSize * 0.45;

      for (let i = 0; i < line.length; i++) {
        const char = line[i];
        const x = startX + i * fontSize * 0.9;
        svg += `  <text x="${x}" y="${startY}" font-family="${fontFamily}" font-size="${fontSize}" fill="red" text-anchor="middle">${char}</text>\n`;
      }
      startY += lineSpacing;
    }
  } else {
    // 기존 세로 배치
    const lineSpacing = fontSize * 1.1;
    const totalTextHeight = lines.reduce((acc, l) => acc + l.length * lineSpacing, 0);
    let currentY = centerY - totalTextHeight / 2 + fontSize * 0.8;

    for (const line of lines) {
      for (let i = 0; i < line.length; i++) {
        const char = line[i];
        svg += `  <text x="${centerX}" y="${currentY}" font-family="${fontFamily}" font-size="${fontSize}" fill="red" text-anchor="middle">${char}</text>\n`;
        currentY += lineSpacing;
      }
    }
  }

  svg += `</svg>`;
  return svg;
}

export const createCanvasStamp = async (text, fontFamily, options = {}) => {
  const width = options.width || 100;
  const height = options.height || 100;
  const strokeColor = options.strokeColor || '#ff0000';
  const strokeWidth = options.strokeWidth || 2.3;

  // 폰트 로드 대기
  await document.fonts.load(`16px '${fontFamily}'`);

  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d');

  const centerX = width / 2;
  const centerY = height / 2;

  let lines = [text];
  let isCircle = text.length >= 4;

  if (isCircle) {
    const mid = Math.ceil(text.length / 2);
    lines = [text.slice(0, mid), text.slice(mid)];
  }

  // 글자 크기 계산
  let fontSize;
  if (isCircle) {
    fontSize = Math.floor(width / (Math.max(...lines.map(l => l.length)) + 1.5));
  } else {
    fontSize = Math.floor(width * 0.2);
  }

  ctx.clearRect(0, 0, width, height);
  ctx.lineWidth = strokeWidth;
  ctx.strokeStyle = strokeColor;
  ctx.fillStyle = 'red';
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.font = `${fontSize}px '${fontFamily}'`;

  // 도형 그리기
  if (isCircle) {
    const r = Math.min(width, height) / 2 - strokeWidth - 2;
    ctx.beginPath();
    ctx.arc(centerX, centerY, r, 0, Math.PI * 2);
    ctx.stroke();
  } else {
    const rx = width * 0.3;
    const ry = height / 2 - strokeWidth - 2;
    ctx.beginPath();
    ctx.ellipse(centerX, centerY, rx, ry, 0, 0, Math.PI * 2);
    ctx.stroke();
  }

  // 글자 그리기
  if (isCircle) {
    const lineSpacing = fontSize * 1.0;
    let startY = centerY - (lines.length * lineSpacing) / 2 + fontSize * 0.5;

    for (const line of lines) {
      const textWidth = line.length * fontSize * 0.9;
      let startX = centerX - textWidth / 2 + fontSize * 0.45;

      for (let i = 0; i < line.length; i++) {
        const char = line[i];
        const x = startX + i * fontSize * 0.9;
        ctx.fillText(char, x, startY);
      }
      startY += lineSpacing;
    }
  } else {
    const lineSpacing = fontSize * 1.1;
    let currentY = centerY - (lines.reduce((acc, l) => acc + l.length * lineSpacing, 0)) / 2 + fontSize * 0.5;

    for (const line of lines) {
      for (let i = 0; i < line.length; i++) {
        const char = line[i];
        ctx.fillText(char, centerX, currentY);
        currentY += lineSpacing;
      }
    }
  }

  return canvas.toDataURL('image/png');
};

export const createCanvasSignature = async (text, fontFamily, options = {}) => {
  const targetWidth = options.width || 300; // 최대 가로 폭
  const strokeColor = options.strokeColor || '#000000';
  const fillColor = options.fillColor || '#000000';

  await document.fonts.load(`16px '${fontFamily}'`);

  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  let fontSize = targetWidth / text.length; // 초기 추정

  ctx.font = `${fontSize}px '${fontFamily}'`;
  let textWidth = ctx.measureText(text).width;

  // 폭을 넘지 않도록 조정
  while (textWidth > targetWidth && fontSize > 5) {
    fontSize -= 1;
    ctx.font = `${fontSize}px '${fontFamily}'`;
    textWidth = ctx.measureText(text).width;
  }

  const textHeight = fontSize;
  canvas.width = Math.ceil(textWidth + 10);
  canvas.height = Math.ceil(textHeight + 10);

  ctx.font = `${fontSize}px '${fontFamily}'`;
  ctx.fillStyle = fillColor;
  ctx.strokeStyle = strokeColor;
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.clearRect(0, 0, canvas.width, canvas.height);

  ctx.fillText(text, canvas.width / 2, canvas.height / 2);

  return canvas.toDataURL('image/png');
};
